export default "__VITE_ASSET__BdMxZuua__"